import { ReactNode } from 'react';
import { getAssetUrl } from '../../../utils/config';
import './style.scss';

const InformationBoxAlt = ({ texts }: { texts: ReactNode[] }) => (
  <div className="information-box-alt" data-test-id="information-box-container">
    <div className="information-box-alt__text-container">
      {texts.map((text, i) => (
        <div className="information-box-alt__text" data-test-id="information-box" key={i}>
          {text}
        </div>
      ))}
    </div>
    <img
      className="information-box-alt__icon"
      src={getAssetUrl('common/infoFill.svg')}
      data-test-id="information-box-icon"
    />
  </div>
);

export default InformationBoxAlt;
